export default function translate(i18n, propriete) {
  let libellePropriete = propriete;
  if (propriete === 'numeroEmetteur') return i18n.t('societes.numeroEmetteur');
  if (propriete === 'masqueLibelleProduitUnitairePatrimonial') {
    return i18n.t('societes.masqueBloc.masqueLibelleProduitUnitairePatrimonial');
  }
  if (propriete === 'masqueLibelleProduitEcranNumeriquePatrimonial') {
    return i18n.t('societes.masqueBloc.masqueLibelleProduitEcranNumeriquePatrimonial');
  }
  if (propriete === 'commentaireFactureIntracommunautaire') {
    return i18n.t('societes.commentaireFactureIntracommunautaire');
  }
  if (propriete === 'delaiAdministratifAchat') return i18n.t('societes.delaiAdministratif.achat');
  if (propriete === 'delaiAdministratifVente') return i18n.t('societes.delaiAdministratif.vente');
  if (propriete === 'lieuStockageDefault') return i18n.t('societes.client.lieuStockageDefault');
  if (propriete === 'retardPaiement') return i18n.t('societes.mentionsLegales.retardPaiement');
  if (propriete === 'nomFichierExportSpe') return i18n.t('societes.errors.nomFichierExportSpe');
  if (propriete === 'tauxMaintenance') return i18n.t('societes.errors.tauxMaintenance');
  if (propriete.indexOf('retroPlanningReseauTempo') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (['delaiLivraisonVisuel', 'DelaiLivraisonVisuel'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonVisuel');
    }
    if (['delaiLivraisonAfficheImprimee', 'DelaiLivraisonAfficheImprimee'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonAfficheImprimee');
    }
    if (['delaiLivraisonAffichePreparee', 'DelaiLivraisonAffichePreparee'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonAffichePreparee');
    }
  }
  if (propriete.indexOf('retroPlanningLc') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (['delaiLivraisonVisuel', 'DelaiLivraisonVisuel'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonVisuelLc');
    }
    if (['delaiLivraisonAfficheImprimee', 'DelaiLivraisonAfficheImprimee'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonAfficheImprimeeLc');
    }
    if (['delaiLivraisonAffichePreparee', 'DelaiLivraisonAffichePreparee'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonAffichePrepareeLc');
    }
  }
  if (propriete.indexOf('retroPlanningReseauLc') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (['delaiLivraisonVisuel', 'DelaiLivraisonVisuel'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonVisuelRxLc');
    }
    if (['delaiLivraisonAfficheImprimee', 'DelaiLivraisonAfficheImprimee'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonAfficheImprimeeRxLc');
    }
    if (['delaiLivraisonAffichePreparee', 'DelaiLivraisonAffichePreparee'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonAffichePrepareeRxLc');
    }
  }
  if (propriete.indexOf('retroPlanningReseauMairie') === 0) {
    libellePropriete = libellePropriete.slice(libellePropriete.indexOf('.') + 1);
    if (['delaiLivraisonVisuel', 'DelaiLivraisonVisuel'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonVisuelRxMairie');
    }
    if (['delaiLivraisonAfficheImprimee', 'DelaiLivraisonAfficheImprimee'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonAfficheImprimeeRxMairie');
    }
    if (['delaiLivraisonAffichePreparee', 'DelaiLivraisonAffichePreparee'].includes(libellePropriete)) {
      return i18n.t('societes.errors.delaiLivraisonAffichePrepareeRxMairie');
    }
  }
  return propriete;
}
